import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { isAfter, isBefore } from 'date-fns';

import { useLocation } from 'react-router-dom';

import useHomeModals from './hooks/useHomeModals';
import { orderShowModal } from './hooks/orderShowModal';
import { orderShowModalBill } from './hooks/orderShowModalBill';
import { config } from './config';
import { TYPE_PROMOTION } from './enums';
import { getNPSStatus } from './services/npsServices';

import {
  Container,
  Content,
  Button,
  ImgBanner,
  CloseContainer,
  ButtonClose,
  TextWrapper,
  TextTitle,
  TextSubTitle,
  ButtonNPSContainer,
  ButtonNPS,
} from './styles';
import {
  getAvailable,
  updateNotification,
} from './services/modalPesquisaSatisfacaoServices';

const BannerPromotions: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [dynamicUrl, setDynamicUrl] = useState<string>('');
  const [idNotification, setIdNotification] = useState<string | null>(null);
  const { handleNextModal, showActiveModal } = useHomeModals();

  // colocamos essa condição para sempre exibir a modal de pesquisa para o usuário
  const granelIsNeedByPass = true;

  const { pathname } = useLocation();

  const [atualPromotion] = useMemo(() => {
    const path = pathname;
    if (path === '/boletos') {
      const [modalType] = orderShowModalBill.filter(
        (order) => order.id === showActiveModal
      );

      if (!modalType) return [];

      return config.filter((conf) => conf.type === modalType.modal);
    }

    const [modalType] = orderShowModal.filter(
      (order) => order.id === showActiveModal
    );

    if (!modalType) return [];

    return config.filter((conf) => conf.type === modalType.modal);
  }, [showActiveModal, pathname]);

  const getInitialParams = useCallback(async () => {
    if (!atualPromotion) return;
    const initialDate = atualPromotion?.start
      ? isBefore(atualPromotion.start, new Date())
      : true;

    const endDate = atualPromotion?.end
      ? isAfter(atualPromotion.end, new Date())
      : true;

    const isClosed =
      localStorage.getItem(
        `@UltragazEmpresarial:${atualPromotion.localStorageKey}`
      ) === 'yes';

    const hasMFAToken = localStorage.getItem('@UltragazEmpresarial:X-Mfa-Hash');

    const path = window.location.pathname;

    let isNeedShowModal =
      atualPromotion.showPath === path && initialDate && endDate && !isClosed;

    if (atualPromotion.type === TYPE_PROMOTION.NPS && isNeedShowModal) {
      isNeedShowModal = (await getNPSStatus(setDynamicUrl)) && !isClosed;
    }

    if (atualPromotion.type === TYPE_PROMOTION.AVISO_MFA && isNeedShowModal) {
      isNeedShowModal = !hasMFAToken;
    }

    if (
      atualPromotion.type === TYPE_PROMOTION.PESQUISA_USABILIDADE &&
      isNeedShowModal
    ) {
      isNeedShowModal =
        (await getAvailable(setIdNotification)) || granelIsNeedByPass;
    }

    setShowModal(isNeedShowModal);
    if (!isNeedShowModal) handleNextModal();
  }, [atualPromotion, handleNextModal, granelIsNeedByPass]);

  useEffect(() => {
    getInitialParams();
  }, [getInitialParams]);

  const saveClosed = useCallback(() => {
    localStorage.setItem(
      `@UltragazEmpresarial:${atualPromotion.localStorageKey}`,
      'yes'
    );
    handleNextModal();
    setShowModal(false);
  }, [atualPromotion, handleNextModal]);

  const handleClick = useCallback(
    (url: string | undefined) => {
      setTimeout(() => {
        window.open(url, '_blank');
      });
      saveClosed();
    },
    [saveClosed]
  );

  const CustomModal = useMemo(() => {
    if (atualPromotion?.CustomModalComponent) {
      return atualPromotion.CustomModalComponent;
    }
    return null;
  }, [atualPromotion]);

  return (
    <>
      {showModal &&
        (CustomModal ? (
          <CustomModal />
        ) : (
          <Container>
            <Content>
              <CloseContainer>
                <ButtonClose
                  onClick={() => {
                    saveClosed();
                  }}
                >
                  X
                </ButtonClose>
              </CloseContainer>
              {atualPromotion?.title && (
                <TextWrapper>
                  <TextTitle
                    dangerouslySetInnerHTML={{ __html: atualPromotion.title }}
                  />
                  {atualPromotion?.subTitle && (
                    <TextSubTitle>{atualPromotion.subTitle}</TextSubTitle>
                  )}
                  {atualPromotion?.dinamicLinkPromotion && (
                    <ButtonNPSContainer>
                      <ButtonNPS onClick={() => handleClick(dynamicUrl)}>
                        Quero participar
                      </ButtonNPS>
                    </ButtonNPSContainer>
                  )}
                </TextWrapper>
              )}
              {atualPromotion?.img && (
                <ImgBanner
                  src={atualPromotion.img}
                  customWidth={atualPromotion?.customWidth}
                  customHeight={atualPromotion?.customHeight}
                  customMobileWidth={atualPromotion?.customMobileWidth}
                  customMobileHeight={atualPromotion?.customMobileHeight}
                  alt="Imagem promocional"
                  isLink={
                    !!atualPromotion?.linkPromotion &&
                    atualPromotion?.buttonLink === false
                  }
                  onClick={() => {
                    if (
                      atualPromotion.linkPromotion &&
                      atualPromotion?.buttonLink === false
                    ) {
                      handleClick(atualPromotion.linkPromotion);
                      if (idNotification) {
                        updateNotification(idNotification);
                      }
                    }
                  }}
                />
              )}
              {atualPromotion.linkPromotion && atualPromotion?.buttonLink && (
                <Button
                  onClick={() => handleClick(atualPromotion.linkPromotion)}
                >
                  Votar
                </Button>
              )}
            </Content>
          </Container>
        ))}
    </>
  );
};

export default BannerPromotions;
